import { jsx as r } from "react/jsx-runtime";
import { propagateTestid as a } from "../../../helpers/utility/propagateTestid.js";
import { forwardRef as m } from "react";
const n = m(
  ({
    "data-testid": i,
    getValuesString: t,
    name: p,
    renderHiddenInput: e,
    value: o
  }, d) => e ? e({
    getValuesString: t,
    value: o,
    ref: d
  }) : /* @__PURE__ */ r(
    "input",
    {
      "data-testid": a(i, "hidden-input"),
      name: p,
      type: "hidden",
      value: t(),
      ref: d
    }
  )
);
n.displayName = "SelectHiddenInput";
export {
  n as SelectHiddenInput
};
